import {
    getShowcaseScrollState,
    getSpectrumScrollBehavior,
    getSpectrumSelectionStatus
} from '../utils/spectrum-showcase-runtime.js';
import { initHubSpotForms } from '../utils/hubspot-forms.js';

const SCROLL_STEP = 500;

const initializeShowcase = (showcase) => {
    const viewport = showcase.querySelector('[data-spectrum-viewport]');
    const colors = Array.from(showcase.querySelectorAll('[data-spectrum-color]'));
    const previous = showcase.querySelector('[data-spectrum-prev]');
    const next = showcase.querySelector('[data-spectrum-next]');
    const status = showcase.querySelector('[data-spectrum-status]');

    if (!viewport || !colors.length || !previous || !next) {
        return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = getSpectrumScrollBehavior(reduceMotion);

    // The left arrow only appears once the strip has been scrolled away from the start.
    // atEnd stays unused: scrollWidth is not final until the swatch images load, and nothing
    // re-fires when it grows, so hiding Next on first paint would strand it hidden.
    const updateControls = () => {
        const { atStart } = getShowcaseScrollState(viewport);
        // Keep keyboard focus on-screen when the focused Previous arrow is hidden.
        if (atStart && !previous.hidden && document.activeElement === previous) {
            next.focus();
        }
        previous.hidden = atStart;
    };

    const selectColor = (selectedColor) => {
        colors.forEach((color) => {
            const isSelected = color === selectedColor;
            color.classList.toggle('is-selected', isSelected);
            color.querySelector('[data-spectrum-select]')?.setAttribute('aria-pressed', String(isSelected));
        });

        const button = selectedColor.querySelector('[data-spectrum-select]');
        if (button && status) {
            status.textContent = getSpectrumSelectionStatus(button.getAttribute('aria-label') || 'Color');
        }
    };

    colors.forEach((color) => {
        color.querySelector('[data-spectrum-select]')?.addEventListener('click', () => selectColor(color));
    });

    previous.addEventListener('click', () => viewport.scrollBy({ left: -SCROLL_STEP, behavior }));
    next.addEventListener('click', () => viewport.scrollBy({ left: SCROLL_STEP, behavior }));

    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
};

const initializeSpectrumPage = () => {
    document.querySelectorAll('[data-spectrum-showcase]').forEach(initializeShowcase);
    initHubSpotForms();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSpectrumPage);
} else {
    initializeSpectrumPage();
}
